import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	apps: {
		defaultMessage: 'Apps',
		id: 'atlassian-navigation.addons.apps',
		description: 'Connect Add-ons primary menu item',
	},
});
